import React from "react";
import CommonNavbar from "../CommonLayout/CommonNavbar";
import CommonFooter from "../CommonLayout/CommonFooter";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const TermsOfUse = () => {
  return (
    <>
      <CommonNavbar />
      <Container style={{ padding: "30px" }}>
        <h2>Terms of Use</h2>
        <div className="mt-4">
          <p>
            <b>Last updated:</b> 27 Feb 2025
          </p>
          <p>
            Welcome to our Psycho Oncology Appointment Platform ("Platform"). By accessing or using this Platform, you agree to be bound by these Terms of Use and our Privacy Policy. Please read these Terms carefully before using our services.
          </p>
          <br />
          <p>
            <b>1. Acceptance of Terms</b>
            <br />
            By registering, booking appointments, or otherwise accessing our Platform, you acknowledge that you have read, understood, and agree to these Terms of Use. If you do not agree with any part of these terms, please do not use the Platform.
          </p>
          <br />
          <p>
            <b>2. Description of Service</b>
            <br />
            Our Platform is a SaaS solution designed for counsellors and clients in the healthcare field. It enables counsellors to manage their availability, connect their Zoom accounts, and automatically generate online meeting links when appointments are booked. Clients can easily book appointments and receive meeting links to join virtual sessions.
          </p>
          <br />
          <p>
            <b>3. User Responsibilities</b>
            <br />
            Users agree to provide accurate and up-to-date information during registration and appointment booking. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
          </p>
          <br />
          <p>
            <b>4. Prohibited Conduct</b>
            <br />
            Users shall not:
            <ul>
              <li>Use the Platform for any unlawful purpose.</li>
              <li>Attempt to gain unauthorized access to any part of the Platform.</li>
              <li>Distribute or share any sensitive personal information without proper consent.</li>
            </ul>
          </p>
          <br />
          <p>
            <b>5. Intellectual Property</b>
            <br />
            All content, features, and functionality on the Platform are the exclusive property of our company or its licensors. You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Platform without express written permission.
          </p>
          <br />
          <p>
            <b>6. Data Collection and Privacy</b>
            <br />
            We collect, store, and use personal data as described in our Privacy Policy. By using the Platform, you consent to such processing. For more information, please review our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>
          <br />
          <p>
            <b>7. Disclaimer of Warranties</b>
            <br />
            The Platform is provided "as is" without any warranties of any kind, either express or implied. We do not warrant that the Platform will be error‑free, uninterrupted, or completely secure.
          </p>
          <br />
          <p>
            <b>8. Limitation of Liability</b>
            <br />
            In no event shall our company be liable for any indirect, incidental, or consequential damages arising from the use or inability to use the Platform.
          </p>
          <br />
          <p>
            <b>9. Changes to the Terms</b>
            <br />
            We reserve the right to update or modify these Terms at any time. Changes will be posted on our website with a revised effective date. Your continued use of the Platform constitutes acceptance of the updated Terms.
          </p>
          <br />
          <p>
            <b>10. Governing Law</b>
            <br />
            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which our company is located.
          </p>
          <br />
          <p>
            <b>11. Contact Us</b>
            <br />
            If you have any questions about these Terms of Use, please contact us at{" "}
            <a href="mailto:info@psychooncology.online">info@psychooncology.online</a>.
          </p>
        </div>
      </Container>
      <CommonFooter />
    </>
  );
};

export default TermsOfUse;
